"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFiocTexts = void 0;
var useFiocTexts_hook_1 = require("./useFiocTexts.hook");
Object.defineProperty(exports, "useFiocTexts", { enumerable: true, get: function () { return useFiocTexts_hook_1.useFiocTexts; } });
//# sourceMappingURL=index.js.map